import { render, staticRenderFns } from "./BButton.vue?vue&type=template&id=3ad4f368"
import script from "./BButton.vue?vue&type=script&lang=js"
export * from "./BButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports